// extracted by mini-css-extract-plugin
export default {"navbarHome":"navbarHome__UF5aq","body":"body__ENftl","logo":"logo__JHk4h","fade-in":"fade-in__VeCKp","socials":"socials__8g2cM"};